import axios from 'axios';

let prefix = "/customer"

const CustomerApi = {

	getCustomerList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getCustomerById(id, payload){
		return axios.get( prefix + "/get/" + id, {params: payload})
	},
	createCustomer(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateCustomer(payload){
		return axios.post( prefix + "/update", payload)
	},
	archiveCustomer(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},
	exportCustomer(payload){
		return axios.get( prefix + "/export", {params: payload, responseType: 'blob'})
	},
	// Email this customer a fresh set-password link. The recovery for accounts
	// created before the invite was wired up, which have no usable password and
	// never received a link.
	resendCustomerSetPassword(payload){
		return axios.post( prefix + "/resend-set-password", payload)
	},

}

export default CustomerApi;